( function( global, $ ) {
    "use strict";

    var ATTEMPT_INTERVAL = 30; // seconds

    var MAX_ATTEMPTS = 30;

    var REMINDERS_LIMIT = 50;

    var MAX_DURATION = 15 * 60; // seconds

    function renderReminders(element, result) {
        var $reminders = $(element);

        $.each(result.items, function() {
            renderReminder(element, this);
        });

        if (result.countNew) {
            $reminders.attr('data-badge', result.countNew);
        } else {
            $reminders.removeAttr('data-badge');
        }
    }

    function renderReminder(element, reminder) {
        // Use handlebars instead would be a better solution...

        var $reminders = $(element),
            $li = $('<li/>');

        $li.attr('data-reminder-id', reminder.id)
            .append('<div>' + reminder.content + '</div>');

        if (reminder.link) {
            $('<a/>').html(reminder.link.label)
                .attr('href', reminder.link.href)
                .attr('data-reminder-link', '')
                .appendTo($li);
        }

        if (reminder.isNew) {
            $li.addClass('is-new');

            $('<button/>').html('J\'ai compris')
                .attr('type', 'button')
                .attr('class', 'pull-right u-margin-top-sm')
                .attr('data-reminders-got-it', '')
                .appendTo($li);
        }

        $reminders.find('> ul').append($li);
    }

    var _events = {
        onStartReminders: function() {
            var $reminders = $(this),
                interval = ATTEMPT_INTERVAL * 1000;

            if (! $reminders.data('reminders.start')) {
                $reminders.data('reminders.start', new Date());
            }

            $reminders.data('reminders.state', 'start');
            $reminders.data('reminders.attempts', 0);

            function attempt() {
                var duration = (new Date()).getTime() - $reminders.data('reminders.start').getTime();

                if (duration / 1000 > MAX_DURATION) {
                    return $reminders.trigger('stop.reminders');
                }

                if ($reminders.data('reminders.attempts') >= MAX_ATTEMPTS ||
                    $reminders.data('reminders.state') === 'pause'
                ) {
                    return $reminders.trigger('pause.reminders');
                }

                clearTimeout($reminders.data('reminders.timeout'));

                $reminders.trigger('refresh.reminders');

                $reminders.data('reminders.timeout', setTimeout(attempt, interval));

                $reminders.data('reminders.attempts', $reminders.data('reminders.attempts') + 1);
            }

            $reminders.data('reminders.timeout', setTimeout(attempt, interval));
        },

        onPauseReminders: function() {
            var $reminders = $(this);

            clearTimeout($reminders.data('reminders.timeout'));

            $reminders.data('reminders.state', 'pause');
        },

        onStopReminders: function() {
            var $reminders = $(this);

            clearTimeout($reminders.data('reminders.timeout'));

            $(document).unbind('click.reminders');

            $reminders.data('reminders.state', 'stop');
        },

        onRefreshReminders: function() {
            var $reminders = $(this);

            // Clear reminders list
            $reminders.find('> ul').html('');

            $reminders.addClass('ajax-loading');

            if ($reminders.data('reminders.ajax') && $reminders.data('reminders.ajax').readyState !== 4) {
                $reminders.data('reminders.ajax').abort();
            }

            $reminders.data('reminders.ajax', $.App.api('GET', 'reminders', {limit: REMINDERS_LIMIT}));
            $reminders.data('reminders.ajax')
                .done(function(response) {
                    if (! response.success) {
                        console.warn('App api error: GET reminders');
                        return;
                    }

                    renderReminders($reminders.get(0), {items: response.result, countNew: response.count_new});
                })
                .always(function() {
                    $reminders.removeClass('ajax-loading');
                });
        },

        onClickGotIt: function() {
            var $gotIt = $(this),
                $item = $gotIt.closest('li'),
                $reminders = $item.closest('[data-reminders]'),
                badgeCount = $reminders.attr('data-badge') - 1;

            $gotIt.hide();
            $item.removeClass('is-new');

            function onAjaxError() {
                $gotIt.show();
                $item.addClass('is-new');
            }
            // Send Request to api
            $.App.api('PATCH', 'reminders/' + $item.data('reminder-id'), {resource: {got_it: true}})
                .done(function(response) {
                    if (! response.success) {
                        console.warn('App api error: PATCH reminders/' + $item.data('reminder-id'));
                        onAjaxError();
                        return;
                    }

                    if (badgeCount > 0) {
                        $reminders.attr('data-badge', badgeCount);
                    } else {
                        $reminders.removeAttr('data-badge');
                    }
                })
                .fail(onAjaxError)
        }
    };

    $('body').on('app.ready', function(ev) {
        var $reminders = $('[data-reminders]');

        if (! $reminders.length) {
            return;
        }

        $reminders
            .on('start.reminders', _events.onStartReminders)
            .on('pause.reminders', _events.onPauseReminders)
            .on('refresh.reminders', _events.onRefreshReminders)
            .on('click.reminders', '[data-reminders-got-it]', _events.onClickGotIt)
            .trigger('refresh.reminders', _events.onRefreshReminders)
            .trigger('start.reminders');

        $(document).on('click.reminders', function() {
            if (-1 === $.inArray('active', $reminders.attr('gr-dropdown').split(' '))) {
                if ($reminders.data('reminders.state') === 'start') {
                    $reminders.data('reminders.attempts', 0);
                } else {
                    $reminders.trigger('start.reminders');
                }
            } else if ($reminders.data('reminders.state') !== 'pause') {
                $reminders.trigger('pause.reminders');
            }
        });
    });

}( window.groots, jQuery ));
